import { render, staticRenderFns } from "./groupsendle.vue?vue&type=template&id=3ab40cd9&scoped=true&"
import script from "./groupsendle.vue?vue&type=script&lang=js&"
export * from "./groupsendle.vue?vue&type=script&lang=js&"
import style0 from "./groupsendle.vue?vue&type=style&index=0&id=3ab40cd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab40cd9",
  null
  
)

export default component.exports